module.exports = __webpack_public_path__ + "static/media/30-10.2b7a07d4.mp3";